import {Button, Empty} from 'gotu-ui'
import Image, {StaticImageData} from 'next/image'
import React, {memo, useEffect} from 'react'
import classNames from 'classnames'
import {captureException} from '@sentry/nextjs'
import nullImg from '@/public/img/error/null.png'
import errorImg from '@/public/img/error/error.png'
import noInternetImg from '@/public/img/error/noInternet.png'
import offlineImg from '@/public/img/error/offline.png'
import emptyImg from '@/public/img/error/empty.png'
import {removeAllRestrictions} from '@/plugins/bridge'
import {useGlobal} from '@/pages/_app'
import {niceTry} from '@/utils'
import TitleBar from '../TitleBar'
import CircularJSON from 'circular-json'

const styles = require('./style.module.less')

export type ErrorType = 'null' | 'error' | 'offline' | 'empty' | 'noInternet'

const configMap: Record<ErrorType, {desc: string; img: StaticImageData}> = {
    null: {desc: '哎呀！页面加载发生意外', img: nullImg},
    error: {desc: '哎呀！页面加载发生意外', img: errorImg},
    offline: {desc: '哎呀！页面加载发生意外', img: offlineImg},
    empty: {desc: '哎呀！页面加载发生意外', img: emptyImg},
    noInternet: {desc: '请检查网络设置或刷新重试', img: noInternetImg},
}

interface CustomErrorProps {
    description?: string;
    type?: ErrorType;
    showBtn?: boolean;
    btnText?: string;
    onBtnClick?: IFn;
    noFixed?: boolean;
    reason: string;
    otherInfo: any;
    onMounted?: IFn;
    noError?: boolean;
    component?: null | React.ReactElement;
    hiddenTitleBar?: boolean;
}

const CustomError = (props: CustomErrorProps) => {
    const {
        description,
        type = 'error',
        showBtn = false,
        btnText = '刷新',
        onBtnClick = () => location.reload(),
        noFixed = false,
        reason,
        otherInfo,
        onMounted,
        noError,
        component,
    } = props
    const {desc, img} = configMap[type]
    const {renderId} = useGlobal()
    useEffect(() => {
        if (!noError) {
            captureException(new Error('错误页面'), (scope) => scope.setExtras({renderId, reason, otherInfo}))
            console.log('renderId: ', renderId)
            console.log('reason: ', reason)
            console.log('otherInfo: ', otherInfo)
        }
        removeAllRestrictions()
        onMounted?.()
    }, [])

    if (component) {
        return component
    }

    return (
        <Empty
            image={(
                <Image
                    src={img}
                    height={120}
                    width={120}
                    priority
                    alt=''
                />
            )}
            description={(
                <>
                    <div className={styles.description}>
                        {description || desc}
                    </div>
                    {showBtn && (
                        <Button
                            fill='outline'
                            shape='rounded'
                            className={styles.btn}
                            onClick={onBtnClick}
                        >
                            {btnText}
                        </Button>
                    )}
                </>
            )}
            className={classNames({[styles.emptyBox]: true, [styles.noFixed]: noFixed})}
            onClick={() => {}}
        />
    )
}

export const CustomErrorPage = (props: CustomErrorProps) => (
    <>
        { props.hiddenTitleBar ? null : <TitleBar /> }
        <CustomError
            type='offline'
            {...props}
        />
    </>
)

export default memo(CustomError)
